
const getStorage = (type, key) => {
  if (type === "session") {
    return JSON.parse(sessionStorage.getItem(key));
  }
  return JSON.parse(localStorage.getItem(key));
};

const setStorage = (type, key, value) => {
  if (type === "session") {
    sessionStorage.setItem(key, value);
  } else {
    localStorage.setItem(key, value);
  }
};

export {
  getStorage,
  setStorage,
};
